import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Inline from '../../elements/inline'
import Icon from '../../elements/icon'
import Box from '../../elements/box'
import Grid from '../../elements/grid'

import './statusbox.scss'

class StatusBox extends Component {
  constructor (props) {
    super(props)
    this.state = {

    }

    this.onClick = this.onClick.bind(this)
  }

  getStyle () {
    return 'element-statusbox'
  }

  getClickable () {
    if (this.props.onClick !== null && this.props.onClick !== undefined) {
      return 'element-box--clickable'
    }
    return ''
  }

  onClick (e) {
    if (this.props.onClick !== null && this.props.onClick !== undefined) {
      this.props.onClick(e)
    }
  }

  getStatusContent () {
    let { icon, title, subTitle } = this.props

    return (
      <Inline align='center' fullWidth>
        <Icon size='l' icon={icon} />
        <div>
          <span className='fontbold'>{title}</span>
          <br />
          <span>{subTitle}</span>
        </div>
      </Inline>
    )
  }

  getChevron () {
    if (!this.props.onClick) return

    const triggerClass = !this.props.chevron ? 'fa fa-chevron-right' : 'fa fa-chevron-down'
    return <i className={triggerClass} />
  }

  render () {
    return (
      <div className={this.getClickable()} onClick={this.onClick}>
        <Box color={this.props.color}>
          <div className={this.getStyle()}>
            <Grid cols={['1fr', 'min-content']} align='center'>
              {this.getStatusContent()}
              {this.getChevron()}
            </Grid>
          </div>
        </Box>
      </div>
    )
  }
}

StatusBox.defaultProps = {
  onClick: null,
  // color: 'red', // colors: 'red', 'green', 'orange', 'blue'
  chevron: false
}

StatusBox.propTypes = {
  color: PropTypes.string.isRequired,
  icon: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired
}

export default StatusBox



// WEBPACK FOOTER //
// ./src/app/shared/components/StatusBox/index.js